/* eslint-disable default-case,no-param-reassign,@typescript-eslint/no-unused-vars */

import { COMPONENT_TYPE } from '../../../../../app/constants/component_type';

xplenty.directive('databaseAdvancedOptionsDestination', [
  '$rootScope',
  '$timeout',
  function ($rootScope, $timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./database-advanced-options-destination.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        function ($scope) {
          $scope.hasIntermediateCompressionType = false;
          $scope.hasTruncateColumns = false;
          $scope.hasTrimBlanks = false;
          $scope.hasNullString = false;
          $scope.hasEmptyAsNull = false;
          $scope.hasBlankAsNull = false;
          $scope.hasReplacementCharacter = false;
          $scope.hasRoundDecimals = false;
          $scope.hasExplicitIds = false;
          $scope.hasCompUpdate = false;

          $scope.hasBatchSize = false;
          $scope.hasParallel = false;
          $scope.hasTransactions = false;
          $scope.hasSplitByField = false;
          $scope.hasMaxErrors = false;
          $scope.hasMaxBadRecords = false;

          if (
            (!$scope.component.split_by_field && $scope.schemaFields && $scope.schemaFields.length) ||
            (!_.some($scope.schemaFields, { name: $scope.component.split_by_field }) &&
              $scope.schemaFields &&
              $scope.schemaFields.length)
          ) {
            $scope.component.split_by_field = $scope.schemaFields[0].name;
          }

          $scope.schemaFieldsOptions = ($scope.schemaFields || []).map(({ name }) => ({ text: name, value: name }));

          $scope.compUpdateOptions = [
            {
              value: 'auto',
              text: 'database-destination-advanced-options.selects.comp_update.options.auto',
              translate: true,
            },

            {
              value: 'on',
              text: 'database-destination-advanced-options.selects.comp_update.options.on',
              translate: true,
            },

            {
              value: 'off',
              text: 'database-destination-advanced-options.selects.comp_update.options.off',
              translate: true,
            },
          ];
          $scope.onCompUpdateValueChange = (comUpdate) => {
            $scope.component.comp_update = comUpdate;
          };

          $scope.compressionTypesOptions = [
            {
              value: 'none',
              text: 'database-destination-advanced-options.selects.intermediate_compression_type.options.none',
              translate: true,
            },
            {
              value: 'gzip',
              text: 'database-destination-advanced-options.selects.intermediate_compression_type.options.gzip',
              translate: true,
            },
          ];
          $scope.onCompressionTypeValueChange = (compresionType) => {
            $scope.component.intermediate_compression_type = compresionType;
          };

          $scope.onSplitByFieldChange = (splitByField) => {
            $scope.component.split_by_field = splitByField;
          };

          switch ($scope.component.componentType) {
            case COMPONENT_TYPE.AMAZON_REDSHIFT_DESTINATION_COMPONENT:
              $scope.hasIntermediateCompressionType = true;
              $scope.hasMaxErrors = true;
              $scope.hasTruncateColumns = true;
              $scope.hasTrimBlanks = true;
              $scope.hasNullString = true;
              $scope.hasEmptyAsNull = true;
              $scope.hasBlankAsNull = true;
              $scope.hasReplacementCharacter = true;
              $scope.hasRoundDecimals = true;
              $scope.hasExplicitIds = true;
              $scope.hasCompUpdate = true;
              $scope.hasCompRows = true;
              break;

            case COMPONENT_TYPE.DATABASE_DESTINATION_COMPONENT:
              $scope.hasBatchSize = true;
              $scope.hasParallel = true;
              $scope.hasTransactions = true;
              $scope.hasSplitByField = true;
              break;

            case COMPONENT_TYPE.BIG_QUERY_DESTINATION_COMPONENT:
              $scope.hasMaxBadRecords = true;
              break;

            case COMPONENT_TYPE.SNOWFLAKE_DESTINATION_COMPONENT:
              $scope.hasMaxErrors = true;
              $scope.hasTruncateColumns = true;
              break;

            case COMPONENT_TYPE.SPANNER_DESTINATION_COMPONENT:
              break;

            case COMPONENT_TYPE.MONGO_DESTINATION_COMPONENT:
              break;
          }

          $scope.checkPositive = function (event) {
            // disable "+,-,."
            if (event.charCode === 43 || event.charCode === 45 || event.charCode === 46) {
              event.preventDefault();
            }
          };
        },
      ],
    };
  },
]);
